export default {
    'offer-no': "رقم العرض",
    'offer-date': "تاريخ العرض",
    'account': "العميل",
    'notes': "الملاحظات",
    'validity-days': "مدة صلاحية العرض",
    'payment-terms': "شروط الدفع",
    "total-price": "الإجمالي",
    "total-net": "الصافي",
    'warehouse': "المستودع",
    "material": "المادة",
    "create-offer": "إنشاء عرض",
    "change-offer-currency": "تغيير عملة العرض",
    "discount-total": "إجمالي الحسم",
    "price-offer-delete": "حذف عرض سعر",
    "are-you-sure-of-delete-price-offer": "هل أنت متأكد من حذف العرض؟",
    "price-offer-update": "تم تحديث العرض ينجاح",
    "draft": "قيد التعديل",
    "sent": "مُرسَل",
    "approved": "مقبول",
    "rejected": "مرفوض"
}